module.exports = __webpack_public_path__ + "img/facebook.c0cd1382.svg";